import {h, Fragment} from "preact"
import { defaultConfig } from "../config"
import { useAppState, HistoryElement } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function History() {
    const { historyItems } = useAppState()

    useEffect(()=>{
        nostojs(function(api) {
            api.loadRecommendations();
        });
    })

    return (
        <div id="ns-autocomplete-history" class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto">
            <div class="ns-w-100">
                {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                    Recently Searched
                </div> */}
                <div>
                {/* <h2 id="predictive-search-products" class="predictive-search__heading text-16 mb-12">Products</h2> */}
                <div class="nosto_element nosto_element_serp" id="Search-bar"></div>
                    {/* {historyItems?.slice(0, defaultConfig.historySize).map(item => (
                        <HistoryElement query={{ query: item }}>
                            <div class="ns-d-flex flex-row ns-justify-content-between ns-clickable ns-py-2 ns-px-4 ns-font-4">
                                {item}
                            </div>
                        </HistoryElement>
                    ))} */}
                </div>
            </div>
        </div>
    )
}
